import { CSSProperties } from 'react';
import { ImageStyle, StyleProp } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { Colors, SharedStyles } from '@shared/styles';

type InitialsAvatarSize = 'large' | 'normal' | 'small' | 'tiny';

export interface InitialsAvatarProps {
  name: string;
  id: number;
  size?: InitialsAvatarSize;
  style?: StyleProp<ImageStyle>;
}

export function InitialsAvatar({ name, id, size = 'normal', style }: InitialsAvatarProps) {
  const backgroundColor = getAvatarBackgroundColor(id);

  return (
    <MBView center style={[!style && SharedStyles.fill, { backgroundColor }, style]}>
      <Text weight="bold" style={getPlaceholderTextStyle(size)}>
        {toInitials(name)}
      </Text>
    </MBView>
  );
}

function getAvatarBackgroundColor(id: number): string {
  return Colors.v2.avatar.user[id % Colors.v2.avatar.user.length];
}

function getPlaceholderTextStyle(size: InitialsAvatarSize): CSSProperties | undefined {
  if (size === 'tiny') {
    return { fontSize: 7 };
  }
  if (size === 'small') {
    return { fontSize: 10 };
  }
  if (size === 'large') {
    return { fontSize: 28 };
  }
  return undefined;
}

function toInitials(name: string): string {
  // https://stackoverflow.com/a/8279881/9117995
  const match = name.match(/\b(\w)/g);
  if (!match) {
    return '';
  }
  return match.join('').slice(0, 2).toUpperCase();
}
